import { createApp } from 'vue'
import Providers from './Providers'
import VueProgressBar from "@aacassandra/vue3-progressbar"
import VueGoogleMaps from '@fawmi/vue-google-maps'
import { install } from "vue3-recaptcha-v2"

const options = {
    color: "#c7932c",
    failedColor: "#874b4b",
    thickness: "5px",
    transition: {
        speed: "0.2s",
        opacity: "0.6s",
        termination: 300,
    },
    autoRevert: true,
    location: "top",
    inverse: false,
}

const mountEl = document.querySelector( "#bpa_providers" )

const app = createApp( Providers, { ...mountEl.dataset } )

app.use( VueProgressBar, options )
app.use( install, {
    sitekey: "6Lcen1MoAAAAAK9oCW9KMS4Ki-aRyH7irvqRzo-c",
    cnDomains: false, // Optional, If you use in China, set this value true
} )
app.use( VueGoogleMaps, {
    load: {
        key: 'AIzaSyBJgqCW4hsZLcG8vfDzn18GuU0qkI4yy8c',
        signing_secrete: 'NlJ0wDp2zf_pzh2vxm36TAhU9oA',
        libraries: "places"
    },
} )

app.config.globalProperties.$filters = {
    capitalize ( value ) {
        return value.toLowerCase()
    }
}

app.mount( '#bpa_providers' )